
export const MenuMobile = () => {
	!function() {
		jQuery('body').on('click', '.open-menu', toggleMenu);
		jQuery('body').on('click', '.open-menu-search', openSearch);
		jQuery('body').on('click', '.menu-item-has-children', toggleSubmenu);
		addHeaderBackground();
	}();

	function toggleMenu() {
		jQuery('body').toggleClass('menu-open');
		jQuery('#nav-icon, .mobile-menu-section, .page-header-mobile').toggleClass('open');
	}

	function toggleSubmenu( e ) {
		const $this = jQuery(this);
		const $link = jQuery(e.target);

		if ( $link.parents('.sub-menu').length ) {
			return;
		}

		if ( e ) e.preventDefault();

		jQuery('.menu-item-has-children.open').not($this).removeClass('open');

		if ( $this.hasClass('open') ) {
			$this.removeClass('open');
		} else {
			$this.addClass('open');
		}

	}

	function openSearch() {
		let focusTimeout = 1;
		if ( ! document.body.classList.contains('menu-open') ) {
			toggleMenu();
			focusTimeout = 450;
		}

		setTimeout(function() {
			jQuery('.mobile-menu-section input.et_pb_s').trigger('focus');
		}, focusTimeout);
	}

	/**
	 * Add a background to the header when the page is scrolled over 50px
	 */
	function addHeaderBackground() {
		const target = document.createElement('div');
		target.style.position = 'absolute';
		target.style.top = '50px';
		document.body.appendChild(target);

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					jQuery('.page-header-mobile').removeClass('scrolled');
				} else {
					jQuery('.page-header-mobile').addClass('scrolled');
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0
		});

		observer.observe(target);
	}
};